import React, {PropsWithChildren} from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonShape, ButtonSizes } from '~src/shared/buttons/basicButtons/BaseButton.sc';
import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';
import HoverInfoIcon from '~src/shared/tooltips/HoverInfoIcon';
import SelectorHandler from '~src/modules/okrs/manageObjectives/shared/SelectorHandler';
import {
  CapitalizeFirst,
  KeyResultsList,
  RightSection,
  SubSectionHeader,
  Title,
} from '~src/modules/okrs/manageObjectives/shared/shared.sc';
import SortSelectorSH from '~src/shared/sortSelector/SortSelector';
import { keyResultsSortOptions } from '~src/modules/reports/shared/constants/sortingOptions';

interface Props {
  hasContent: boolean;
  sort?: string;
  onSort?: (sort: string) => void;
  trigger: () => void;
  readonly?: boolean;
}

const KeyResultsListWrapper: React.FC<PropsWithChildren<Props>> = (props) => {
  const { hasContent, onSort, sort } = props;

  const onClick = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();
    props.trigger();
  };

  const [t] = useTranslation();
  return (
    <SelectorHandler iconName="iconClipBoard" hoverTextKey="x.objective.add.icon.key-result">
      {() => (
        <>
          <SubSectionHeader>
            <Title className="sub_title" $active>
              <span data-translation="x.objective.add.key.result.title.info">
                {t('x.objective.add.key.result.title.info')}
              </span>
              <HoverInfoIcon
                infoText={{
                  key: 'x.objective.add.key.result.info',
                  txt: t('x.objective.add.key.result.info'),
                }}
              />
            </Title>
            <RightSection>
              {onSort ? (
                <SortSelectorSH
                  sortingOptions={keyResultsSortOptions('en_US')}
                  selectedSorting={sort}
                  sortList={onSort}
                  selectorWithLabel
                />
              ) : null}
            </RightSection>
          </SubSectionHeader>
          {hasContent && <KeyResultsList>{props.children}</KeyResultsList>}
          {!props.readonly && (
            <SecondaryButton
              $buttonShape={ButtonShape.Oval}
              $buttonSize={ButtonSizes.Medium}
              data-translation="x.objective.add.key.result.add.button.text"
              onClick={onClick}
              style={{ margin: '10px 0' }}
            >
              <CapitalizeFirst>{t('x.objective.add.key.result.add.button.text')}</CapitalizeFirst>
            </SecondaryButton>
          )}
        </>
      )}
    </SelectorHandler>
  );
};

export default KeyResultsListWrapper;
